module.exports = __webpack_public_path__ + "static/media/aymen.ea6db742.jpg";